<template>
    <div class="wrapper">
        <div class="left-detail">
            <div class="button"><button @click="ReturnOrder">返回订单列表</button></div>
            <div class="order-msg">
                <ul>
                    <li><span class="title">合同订单号 :</span><span class="text">{{order.contract_number}}</span><span class="change" @click="changeContractNumber(order)" v-if="order.status===0">[ 修改 ]</span></li>
                    <li><span class="title">预约时间 :</span><span class="text" >{{addressInfo.is_yuyue_str!==''&&addressInfo.is_yuyue_str!=='0'?addressInfo.is_yuyue_str:'未预约'|formatter}}</span><span class="change" v-if="order.status === 0"  @click="changeYuyue(addressInfo)">[ 修改 ]</span></li>
                    <li><span class="title">下单时间 :</span><span class="text">{{order.addtime|formatter}}</span><span class="change" v-if="order.status===0" @click="changeXiadan(order)">[ 修改 ]</span></li>
                    <li><span class="title">收款方式 :</span><span class="text">{{order.pay_name}}(<span v-for="item in order.pay_all" v-show="item.pay_name!=='线下付款'">{{item.pay_name}}: {{item.order_amount}}元　</span>)</span>
                            <PayStyleDialog
                                v-if="order.status===0"
                                :update="getOrderDetail"
                                :order="order"
                                style="display: inline-block"
                            ><span style="color: #0068b7;cursor: pointer">[ 修改 ]</span></PayStyleDialog>
                    </li>
                    <li><span class="title">订单总额 :</span><span class="text">￥{{order.goods_amount}}</span><span class="change"></span></li>
                </ul>
                <ul class="mt20">
                    <li><span class="title">客户 :</span><span class="text">{{addressInfo.consignee}}</span>
                        <AddressDialog
                            v-if="order.status===0"
                            :type="4"
                            :editData.sync="addressInfo"
                            :order="order"
                            :getOrderDetail="getOrderDetail"
                        >
                            <span class="change">[ 修改 ]</span>
                        </AddressDialog>
                    </li>
                    <li><span class="title">电话 :</span><span class="text">{{addressInfo.mobile}}(备用:{{addressInfo.tel}})</span>
                        <AddressDialog
                            v-if="order.status===0"
                            :type="4"
                            :editData.sync="addressInfo"
                            :order="order"
                            :getOrderDetail="getOrderDetail"
                        >
                            <span class="change">[ 修改 ]</span>
                        </AddressDialog></li>
                    <li><span class="title">地址 :</span><span class="text">{{addressInfo.address_str}}</span>
                        <AddressDialog
                            v-if="order.status===0"
                            :type="4"
                            :editData.sync="addressInfo"
                            :order="order"
                            :getOrderDetail="getOrderDetail"
                        >
                            <span class="change">[ 修改 ]</span>
                        </AddressDialog></li>
                    <li><span class="title">备注 :</span><span class="text">{{order.postscript}}</span><span class="change" @click="changeBeizhu(order)" v-if="order.status ==0">[ 修改 ]</span></li>
                    <li><span class="title">收货类型 :</span><span class="text">{{order.inv_type}}</span><span class="change" @click="changeFapiao(order)" v-if="order.status ==0">[ 修改 ]</span></li>
                    <li><span class="title">收货名称 :</span><span class="text">{{order.inv_payee}}</span><span class="change" @click="changeFapiao(order)" v-if="order.status ==0">[ 修改 ]</span></li>
                    <li><span class="title">仓库 :</span><span class="text">{{order.store_storage}}</span><span class="change" @click="changeStorage(order)" v-if="order.status ==0">[ 修改 ]</span></li>
                </ul>
            </div>
            <div class="order-list">
                <div class="title">商品</div>
                <div class="goods" v-for="item in goods_list">
                    <!--<img :src="$reqUrl+item.goods_img">-->
                    <span style="width: 33%">{{item.goods_attr.indexOf('外机型号')!==-1?'':'型号:'}}{{item.goods_attr.indexOf('外机型号')!==-1?item.goods_attr:item.goods_attr_select[0]?item.goods_attr_select[0]:item.goods_attr}}</span>
                    <span style="width:30%">价格:{{item.goods_price}}</span>
                    <span>数量:{{item.goods_number}}</span>
                    <Dialogsa
                        :goods_attr_list="item.goods_attr_list"
                        :goods_attr_id="item.goods_attr_id"
                        :goods_id="item.goods_id"
                        :rec_id="item.rec_id"
                        :product_id="item.product_id"
                        :referer="order.referer"
                        :order_sn="order.order_sn"
                        :goods_price="Number(item.goods_price.split('￥')[1].split('元')[0])"
                        :order_id="item.order_id"
                        :goods_number="item.goods_number"
                        :getCartProducts="getCartProducts"
                        :getOrderList="getOrderDetail"
                    >
                        <div style="cursor: pointer;" class="mt20"><span class="change" v-if="order.status===0">[ 修改 ]</span></div>
                    </Dialogsa>
                    <Confirm
                        :handleConfirm="()=>deleteOrder(goods_list,item.rec_id)" :loading="btnLoading">
                        <div  style="cursor: pointer"><span style="color: red" v-show="order.status === 0">[ 删除 ]</span></div>
                    </Confirm>
                </div>
              <button class="add-goods" @click="addorder(order.order_id,order.order_sn)" v-show="order.status === 0">添加商品</button>
            </div>
            <div class="order-btn">
                <button @click="dayinOrder(order)">打印合同</button>
                <button v-if="order.status ===0" @click="querenOrder(order.order_id)">设置为已支付</button>
                <button v-else-if="(order.status ===2||order.status ===1)&&order.is_yuyue==0" style="background:#f3701e;" @click="quxiaoOrder(order.order_id)">设置为未支付</button>
                <button v-if="order.single_number !==''&&order.status===0" @click="handleClicks(order.order_id)">支付</button>
                <button v-if="order.pay_name==='线下付款'&&(order.referer!=='门店'||order.referer!=='扫码')" @click="handleClick">上传凭证</button>
            </div>
            <div class="order-msg">
                <ul>
                    <li><span class="title">经销商 :</span><span class="text">{{order.user_name}}</span><span class="change" @click="jingxiao(order)" v-if="order.status===0">[ 修改 ]</span></li>
                    <li><span class="title">下单操作员 :</span><span class="text">{{order.xiadanname}}</span></li>
                    <!--<li><span class="title">确认订单 :</span><span class="text">{{order.handle[0]?order.handle[0].user_name:''}}</span></li>-->
                    <!--<li><span class="title">确认时间 :</span><span class="text">{{order.handle[0]?order.handle[0].addtime:''|formatter}}</span></li>-->
                    <li><span class="title">分配方式 :</span><span class="text">{{install!=false?install.delivery_method:''|dev_method}}</span></li>
                    <li><span class="title">安装公司 :</span><span class="text">{{install!=false?install.company_name:''}}</span></li>
                    <li><span class="title">分配时间 :</span><span class="text">{{install!=false&&install.delivery_method !== ''?install.addtime:''|formatter}}</span></li>
                    <li><span class="title">安装队 :</span><span class="text">{{install!=false?install.team_name:''}}</span></li>
                    <!--<li><span class="title">发货日期 :</span><span class="text">{{install!=false?install.delivery_method:''}}</span></li>-->
                    <!--<li><span class="title">订单变更 :</span><span class="text">{{install!=false?install.delivery_method:''}}</span></li>-->
                    <li><span class="title">变更日期 :</span><span class="text">{{install!=false?install.change_time:''|formatter}}</span></li>
                    <li><span class="title">完工日期 :</span><span class="text">{{install!=false?install.finish_time:''|formatter}}</span></li>
                </ul>
                <div style="text-align: center;color: #0068b7;">订单变更</div>
                <el-table
                :data="order.handle"
                style="background: #dedede"
                empty-text="暂无变更记录~"
                >
                    <el-table-column label="操作人" prop="user_name"></el-table-column>
                    <el-table-column label="操作" prop="handle"></el-table-column>
                    <el-table-column label="操作时间" >
                        <template slot-scope="props">{{props.row.addtime|formatters}}</template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="right-detail">
            <h3 style="text-align: left">{{order.referer==='门店'||order.referer==='扫码'?'附件:':'凭证:'}}<el-button style="margin-left: 20px" size="small" type="primary" @click="wangong(order)" v-if="order.referer==='门店'||order.referer==='扫码'">上传附件</el-button></h3>
            <div class="img-box" style="text-align: center" :style="{display:showImgPath ==''?'none':'block'}"><img v-drag="greet" id="drag" :src="$reqUrl + showImgPath" v-show="showImgPath!==''" class="show-img" :style="{transform:'rotate('+rotate+'deg)',height:imgwidth+'px',}"></div>
            <div class="img-box" style="text-align: center" :style="{display:showPzPath ==''?'none':'block'}"><img v-drag="greet" id="drags" :src="$reqUrl + showPzPath" v-show="showPzPath!==''" class="show-img" :style="{transform:'rotate('+rotate+'deg)',height:imgwidth+'px',}"></div>
            <div style="position: relative;z-index: 999;margin: 20px 0" v-if="showImgPath!==''||showPzPath!==''">
                <i class="el-icon-zoom-out" style="color: #ff0300;font-size: 30px;margin: 5px 20px;cursor: pointer;z-index: 999" @click="suoxiao"></i>
                <i class="el-icon-zoom-in" style="color: #ff0300;font-size: 30px;margin: 5px 20px;cursor: pointer;z-index: 999" @click="fanda"></i>
                <i class="el-icon-refresh" style="color: #ff0300;font-size: 30px;margin: 5px 20px;cursor: pointer;z-index: 999" @click="turnLeft"></i>
            </div>
            <div v-if="item !==''" style="display: inline-block;margin:0 20px;text-align: center;" v-for="item in order.order_images">
                <img :src="$reqUrl+item"  style="height: 150px;cursor: pointer;display: inline-block;"  v-show="order.order_images!==''" @click="fujian(item)">
                <div><el-button type="text" @click = "deleteImgs(item)">删除</el-button></div>
            </div>
            <div v-if="item !==''" style="display: inline-block;margin:0 20px;text-align: center;" v-for="item in order.pay_images">
                <img :src="$reqUrl+item" v-if="item !==''" style="width: 30%; cursor: pointer;display: inline-block;" v-show="order.pay_images!==''" @click="fujian1(item)">
                <!--<div><el-button type="text" @click = "deleteImgs(item)">删除</el-button></div>-->
            </div>

        </div>
        <el-dialog
            title="修改备注"
            :visible.sync="showBeizhu"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="备注:" :label-width="formLabelWidth">
                    <el-input v-model="beizhu" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showBeizhu = false">取 消</el-button>
                <el-button type="primary" @click="qrBeizhu">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改仓库"
            :visible.sync="showStorage"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="仓库:" :label-width="formLabelWidth">
                    <el-select v-model="store_storage">
                        <el-option v-for="item in cangkuList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showStorage = false">取 消</el-button>
                <el-button type="primary" @click="qrStorage">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改经销商"
            :visible.sync="showJingxiao"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="经销商:">
                    <el-form-item label="经销商">
                        <el-autocomplete
                            class="inline-input"
                            v-model="agency"
                            :fetch-suggestions="querySearchgy2"
                            placeholder="请输入经销商"
                            @select="handleSelectgy2"
                            style="width: 60%"
                        ></el-autocomplete>
                    </el-form-item>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showJingxiao = false">取 消</el-button>
                <el-button type="primary" @click="qrJingxiao">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改发票"
            :visible.sync="showFapiao"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="收货类型:" :label-width="formLabelWidth">
                    <el-radio v-model="inv_type" label="送货到客户">送货到客户</el-radio>
                    <el-radio v-model="inv_type" label="送货到公司">送货到公司</el-radio>
                </el-form-item>
                <el-form-item label="收货名称:" :label-width="formLabelWidth">
                    <el-input v-model="inv_payee" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showFapiao = false">取 消</el-button>
                <el-button type="primary" @click="qrFapiao">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改预约时间"
            :visible.sync="showYuyue"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="预约时间:" :label-width="formLabelWidth">
                    <el-date-picker
                        v-model="yuyue_time"
                        type="date"
                        placeholder="选择日期"
                    @change="changeData">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showYuyue = false">取 消</el-button>
                <el-button type="primary" @click="qrYuyue">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="修改预约时间"
            :visible.sync="showXiadan"
            width="500px"
        >
            <el-form :model="form">
                <el-form-item label="预约时间:" :label-width="formLabelWidth">
                    <el-date-picker
                        v-model="xiadan_time"
                        type="date"
                        placeholder="选择日期"
                        >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showXiadan = false">取 消</el-button>
                <el-button type="primary" @click="qrXiadan">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="上传附件" :visible.sync="Finish" width="500px">
            <el-form :model="forms" style="margin-top: 30px;padding: 0 30px;text-align: left">
                <el-form-item label="上传图片:" :label-width="formLabelWidth">
                    <el-upload
                        class="upload-demo"
                        action="https://jsonplaceholder.typicode.com/posts/"
                        :limit="limit"
                        :on-remove='removepz1'
                        :http-request='upImgs1'
                        :on-exceed="handleExceed1"
                        :before-upload="beforeAvatarUpload1"
                        list-type="picture">
                        <el-button size="small" type="primary">选择图片</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button  @click="Finish = false">取消</el-button>
                <el-button type="primary" @click="qrFinish">确认上传</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改合同订单号" :visible.sync="changeOrderNumber" width="500px">
            <el-form :model="changeForm" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="合同订单号:" :label-width="formLabelWidth">
                    <el-input v-model="changeForm.contract_number"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="ChangeConOrder" :loading="isbtnload">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import qs from 'qs'
    import AddressDialog from '../components/Common/AddressDialog.vue';
    import PayStyleDialog from '../components/Common/PayStyleDialog.vue';
    import Confirm from '../components/Common/Confirm.vue';
    import { getOrderDetail, host, cancelOrder, deleteOrders, deleteOrder, getCartProducts } from '../stores/api';
    import { statusMap } from '../utils/config';
    import Vue from 'vue';

    Vue.component('AddressDialog', AddressDialog);
    Vue.component('PayStyleDialog', PayStyleDialog);
    Vue.component('Confirm', Confirm);
    Vue.directive('drags', //自定义指令JS
        {bind: function (el, binding) {
                let oDiv = el;   //当前元素
                let self = this;  //上下文
                oDiv.onmousedown = function (e) {
                    //鼠标按下，计算当前元素距离可视区的距离
                    let disX = e.clientX - oDiv.offsetLeft;
                    let disY = e.clientY - oDiv.offsetTop;

                    document.onmousemove = function (e) {
                        //通过事件委托，计算移动的距离
                        let l = e.clientX - disX;
                        let t = e.clientY - disY;
                        //移动当前元素
                        oDiv.style.left = l + 'px';
                        oDiv.style.top = t + 'px';
                        //将此时的位置传出去
                        binding.value({x:e.pageX,y:e.pageY})
                    };
                    document.onmouseup = function (e) {

                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                };
            }
        }
    );
    Vue.directive('drag', //自定义指令                                      JS
        {bind: function (el, binding) {
                let oDiv = el;   //当前元素
                let self = this;  //上下文
                oDiv.onmousedown = function (e) {
                    //鼠标按下，计算当前元素距离可视区的距离
                    let disX = e.clientX - oDiv.offsetLeft;
                    let disY = e.clientY - oDiv.offsetTop;

                    document.onmousemove = function (e) {
                        //通过事件委托，计算移动的距离
                        let l = e.clientX - disX;
                        let t = e.clientY - disY;
                        //移动当前元素
                        oDiv.style.left = l + 'px';
                        oDiv.style.top = t + 'px';
                        //将此时的位置传出去
                        binding.value({x:e.pageX,y:e.pageY})
                    };
                    document.onmouseup = function (e) {

                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                };
            }
        }
    );
    export default {
        data () {
            return {
                dialogVisible: false,
                showBeizhu: false,
                showStorage:false,
                showJingxiao: false,
                showFapiao: false,
                showYuyue: false,
                showXiadan: false,
                Finish: false,
                statusMap: statusMap,
                host: host,
                order: '',
                addressInfo: '',
                install: '',
                steps: [],
                activeStep: '',
                goods_list: [],
                invoice: null,
                fujianPath: '',
                rotate: 0,
                imgwidth: 500,
                formLabelWidth: '120px',
                order_id: '',
                order_sn: '',
                beizhu: '',
                inv_type: '',
                inv_payee: '',
                yuyue_time: '',
                xiadan_time: '',
                limit: 20, //限制三张根图片
                formData1: [],
                baseImg1: '',
                removeImg: '',
                agency: '', //经销商
                agency_id: '', //经销商id

                changeOrderNumber: false,
                changeForm: {contract_number: '', order_id: ''}, //修改合同订单号
                val: '123',
                style: {
                    position: 'absolute',
                    top: 0
                },
                showImgPath: '', //显示附件大图
                showPzPath: '', //凭证大图
                restaurantgy2: [],
                store_storage:'正价仓',
                cangkuList:[]
            };
        },
        beforeMount () {
            this.getOrderDetail();
        },
        filters: {
            formatter(time) {
                if (time !== '' && time !== '0' && time !== '未预约') {
                    return new Date(Number(time) * 1000).toLocaleDateString().replace(/\//g, "-")
                } else {
                    return ''
                }
            },
            formatters(time) {
                if (time !== '' && time !== '0' && time !== '未预约') {
                    return new Date(Number(time) * 1000).toLocaleDateString().replace(/\//g, "-") + ' ' + new Date(Number(time) * 1000).getHours()+ ':' +  new Date(Number(time) * 1000).getMinutes()
                } else {
                    return ''
                }
            },
            dev_method(val) {
                if (val === '0' && val !== '8') {
                    return '送货'
                } else if (val === '1') {
                    return '物流'
                } else if (val === '2') {
                    return '自提'
                } else if (val === '3') {
                    return '送装'
                } else if (val === '4') {
                    return '快递'
                } else if (val === '5') {
                    return '直发'
                } else if (val === '6') {
                    return '其他'
                } else if (val === '9') {
                    return '铺管'
                } else if (val === '10') {
                    return '只安装'
                }
            }
        },
        created() {
          this.getStaffListgy1()
        },
        methods: {
            handleClicks () {
                setInterval(() => {
                    this.getOrderDetail();
                }, 3000)
                window.open(host + '/flow.php?step=order_pay&id=' + this.order.order_id + '&type=huodong');
            },
            changeData() {
              console.log(Date.parse(this.yuyue_time.toLocaleDateString()).toString().slice(0, 10))
            },
            greet(val) {
                this.val = val;
            },
            getOrderDetail () {
                getOrderDetail(this.$route.params.id).then(res => {
                    this.order = res.data.orders;
                    this.store_storage = res.data.orders.store_storage;
                    this.order_sn = res.data.orders.order_sn
                    this.goods_list = res.data.goods_list;
                    this.invoice = res.data.inv;
                    this.steps = res.data.orders.status_nav;
                    this.addressInfo = res.data.address;
                    this.install = res.data.install;
                    this.cangkuList = res.data.storage;
                    if (res.data.orders.order_images.length !== 0) {
                        this.showImgPath = res.data.orders.order_images[0]
                    }
                    if (res.data.orders.pay_images.length !== 0) {
                        this.showPzPath = res.data.orders.pay_images[0]
                    }
                    // console.log(this.addressInfo)
                    for (let i = 0, len = res.data.orders.status_nav.length; i < len; i++) {
                        if (res.data.orders.status_nav[i].time === '') {
                            this.activeStep = i;
                            break;
                        }
                    }
                });
            },
            //修改备注
            changeBeizhu(order) {
                this.order_id = order.order_id
                this.beizhu = order.postscript
                this.showBeizhu = true
            },
            //修改备注
            changeStorage(order) {
                this.order_id = order.order_id
                this.storage = order.storage_storage
                this.showStorage = true
            },
            jingxiao(order) {
                this.order_id = order.order_id
                this.agency = order.user_name
                this.showJingxiao = true
            },
            changeFapiao(order) {
                this.order_id = order.order_id
                this.inv_type = order.inv_type
                this.inv_payee = order.inv_payee
                this.showFapiao = true
            },
            changeYuyue(item) {
              this.showYuyue = true
                this.yuyue_time = item.is_yuyue_str === '' || item.is_yuyue_str === '0'?new Date(): item.is_yuyue_str * 1000
            },
            qrYuyue() {
                var datas = {
                    order_sn: this.order.order_sn,
                    yuyue_time: Date.parse(this.yuyue_time.toLocaleDateString()).toString().slice(0, 10),
                    order_id: this.order.order_id,
                    status: '8',
                }
                this.$http.post(this.$reqUrl + `bind_order.php?act=post_orders_yuyue&session_id = ${localStorage.getItem('shouhou_session_id')}`, qs.stringify(datas)).then( res => {
                    if (res.data.error === 0) {
                        this.$message.success('预约成功')
                        this.showYuyue = false
                        this.getOrderDetail()
                    }
                })
            },
            qrXiadan() {
                let h = this.xiadan_time.getHours()
                let m = this.xiadan_time.getMinutes()
                let s = h * 60 * 60 + m * 60
                let data = {
                    'session_id': localStorage.getItem('shouhou_session_id'),
                    'order_id': this.order.order_id,
                    'add_time': +Date.parse(new Date(this.xiadan_time).toLocaleDateString()).toString().slice(0, 10) + s,
                    'contract_number': this.order.contract_number,
                }
                this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data))
                    .then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('更改成功')
                            this.showXiadan = false
                            this.getOrderDetail()
                        }
                    })
            },
            changeXiadan(item) {
               this.showXiadan = true
                this.xiadan_time = item.addtime * 1000
            },
            //修改合同订单号
            changeContractNumber (row) {
                this.changeOrderNumber = true
                this.changeForm.contract_number = row.contract_number
                this.changeForm.order_id = row.order_id
            },
            ChangeConOrder() {
                if (this.changeForm.contract_number === '') {
                    this.$message.error('合同订单号不能为空')
                } else {
                    let data = {
                        'session_id': localStorage.getItem('shouhou_session_id'),
                        'order_id': this.changeForm.order_id,
                        contract_number: this.changeForm.contract_number
                    }
                    this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('修改成功')
                            this.changeOrderNumber = false
                            this.getOrderDetail()
                        }
                    })
                }
            },
            getStaffListgy1 () {
                this.$http.get(this.$reqUrl + `user.php?act=users_list`).then(res => {
                    this.restaurantgy2 = []
                    if (res.data.data.length !== 0) {
                        res.data.data.forEach((item, index) => {
                            this.restaurantgy2.push({value: item.user_name, id: item.user_id})
                        })
                    }
                })
            },
            querySearchgy2(queryString, cb) {
                var restaurantgy2 = this.restaurantgy2;
                var results = queryString ? restaurantgy2.filter(this.createFiltergy2(queryString)) : restaurantgy2;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFiltergy2(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectgy2(item) {
                this.agency_id = item.id
            },
            qrJingxiao() {
                let data = {
                    session_id: localStorage.getItem('shouhou_session_id'),
                    order_id: this.order_id,
                    agency: this.agency,
                    agency_id: this.agency_id
                }
                this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('修改成功')
                        this.showJingxiao = false
                        this.getOrderDetail()
                    } else if (res.data.error === 0) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            qrBeizhu () {
                let data = {
                    'session_id': localStorage.getItem('shouhou_session_id'),
                    order_id: this.order_id,
                    postscript: this.beizhu
                }
                this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('修改成功')
                        this.showBeizhu = false
                        this.getOrderDetail()
                    } else if (res.data.error === 1) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            qrStorage () {
                let data = {
                    'session_id': localStorage.getItem('shouhou_session_id'),
                    order_id: this.order_id,
                    store_storage: this.store_storage
                }
                this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('修改成功')
                        this.showStorage = false
                        this.getOrderDetail()
                    } else if (res.data.error === 1) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            qrFapiao () {
                let data = {
                    'session_id': localStorage.getItem('shouhou_session_id'),
                    order_id: this.order_id,
                    inv_type: this.inv_type,
                    inv_payee: this.inv_payee
                }
                this.$http.post(this.$reqUrl + 'user.php?act=update_order_address', qs.stringify(data)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success('修改成功')
                        this.showFapiao = false
                        this.getOrderDetail()
                    } else if (res.data.error === 1) {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            //上传附件
            wangong (row) {
                this.Finish = true
                this.order_sn = row.order_sn
                // this.formData1 = []
            },
            upImgs1(item) {
                this.removeImg = item
                let self = this;
                var file = item.file
                var reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = function(e) {
                    self.baseImg1=this.result
                    self.formData1.push( self.baseImg1);
                }
            },
            handleExceed1() {
                this.$message.error('每次只能上传一张图片')
            },
            beforeAvatarUpload1(file) {
                if (!/image\/\w+/.test(file.type)) {
                    this.$message.error('只能上传图片')
                    return false
                }
            },
            //移除凭证钩子
            removepz1(val) {
                console.log(val)
                Array.prototype.remove = function (val) {
                    var index = this.indexOf(val);
                    if (index > -1) {
                        this.splice(index, 1);
                    }
                };
                var file = val.raw
                var reader = new FileReader()
                reader.readAsDataURL(file)
                let self = this;
                reader.onload = function(e) {
                    self.formData1.remove(this.result);
                }
            },
            //确认上传
            qrFinish () {
                console.log(this.formData1)
                if (this.formData1.length === 0) {
                    this.$message.error('请选择图片')
                }else if (this.formData1.length!==0) {
                    let dates = {
                        order_sn:this.order_sn,
                        order_images:this.formData1
                    }
                    // console.log(this.formData.length)
                    this.$http.post(this.$reqUrl + `supply.php?step=update_order_files&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(dates)).then(res=>{
                        if (res.data.error === 0) {
                            this.$message.success('上传成功')
                            this.Finish = false
                            this.getOrderDetail()
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            },
            //删除附件
            deleteImgs (i) {
                let img = i
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post(this.$reqUrl + `supply.php?step=delete_order_files&session_id=${localStorage.getItem('shouhou_session_id')}&order_sn=${this.order_sn}&image=${img}`).then(res=>{
                        if (res.data.error === 0) {
                            this.$message.success('删除成功')
                            this.getOrderDetail()
                        }
                    })
                })
            },

            turnLeft() {
                this.rotate -= 90
                // this.imgwidth += 100
            },
            turnRight() {
                this.rotate += 90
            },
            suoxiao() {
                this.imgwidth -= 50
            },
            fanda() {
                this.imgwidth += 50
            },
            //返回订单列表
            ReturnOrder () {
                localStorage.setItem('isDetail', true)
                this.$router.push('/OrderLists')
            },
            //附件
            fujian(path) {
                this.dialogVisible = true
                this.fujianPath = path
                this.showImgPath = path
            },
            fujian1(path){
                this.showPzPath = path
                this.rotate = 0
                this.imgwidth = 500
            },
            handleClick () {
                window.open(host + '/flow.php?step=order_pay&id=' + this.order.order_id);
            },
            //添加商品
            addorder(order, order_sn) {
                localStorage.setItem('order_id', order);
                localStorage.setItem('order_sn', order_sn);
                this.$router.push('/SupplyChain/AddProduct');
            },
            //打印合同
            dayinOrder(order) {
                window.open(host + '/admin/order.php?act=info&order_id=' + order.order_id + '&print=' + 1);
            },
            //设置为支付
            querenOrder (id) {
                this.$alert('是否确认该订单', '确认订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=mendian_confirm&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderDetail()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            //设置为未支付
            quxiaoOrder (id) {
                this.$alert('是否设置该订单为未支付', '设置订单', {
                    confirmButtonText: '确定',
                }).then(() => {
                    this.$http.get(this.$reqUrl + `user.php?act=change_order_to_unpay&session_id=${localStorage.getItem('shouhou_session_id')}&order_id=${id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                        } else if (res.data.error === 1) {
                            this.$message.error(res.data.msg)
                        }
                        this.getOrderDetail()
                    }).catch(err => {
                        console.log(err)
                    })
                })
            },
            cancelOrder () {
                this.isShow = false;
                cancelOrder(this.order.order_sn).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '订单已取消',
                    });
                    this.order.status = 1;
                    this.getOrderDetail()
                }).catch(err => {
                    this.$notify.error({
                        title: '操作成功',
                        message: err.message,
                    });
                });
            },
            deleteOrders () {
                deleteOrders(this.order.order_sn).then(res => {
                    if (res.data.error === 0) {
                        this.$notify.success({
                            title: '操作成功',
                            message: '该订单已移除',
                        });
                        this.$router.push({path: '/OrderLists'})
                    }
                })
            },
            deleteOrder(order, rec_id) {
                this.btnLoading = true;
                console.log(rec_id);
                console.log(order)
                deleteOrder(order, rec_id).then((res) => {
                    this.$notify.success({
                        title: '操作成功',
                        message: '该订单已删除',
                    });
                    this.cancelVisible = false;
                    this.visible = false;
                    // this.btnLoading = false;
                    if (this.goods_list.length === 1) {
                        this.$router.push('/orderLists')
                    }
                    this.getOrderDetail();
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                }).then(() => {
                    this.btnLoading = false;
                });
            },
        },
        mounted() {

        }
    };
</script>
<style lang="less" scoped>
    .wrapper{
        display: flex;
        flex-wrap: nowrap;
    }
    button{
        cursor: pointer;
    }
    .wrapper .left-detail{
        width: 40%;
        box-sizing: border-box;
        padding: 10px 10px ;
    }
    .left-detail .button button{
        padding: 10px 15px;
        border: 0;
        border-radius: 3px;
        background-color: #999;
        color: white;
    }
    .change{
        color: #0068b7;
        cursor: pointer;
    }
    .left-detail .order-msg{
        border-bottom: 1px solid #dedede;
        padding: 20px 0;
        >ul>li{
            .title{
                display: inline-block;
                margin-right: 20px;
                line-height: 30px;
                font-weight: bold;
            }
            .text{
                color: #f74845;
                padding-right: 15px;
            }

        }
    }
    .left-detail .order-list{
        text-align: center;
        padding: 25px 0;
        border-bottom: 1px solid #dedede;
    }
    .left-detail .order-list .title{
        font-size: 20px;
        font-weight: 600;
        text-align: center;
    }
    .order-list .goods{
        display: block;
        text-align: left;
        /*flex-wrap: nowrap;*/
        /*justify-content: space-between;*/
    }
    .order-list .add-goods{
        border: 0;
        color: white;
        background-color:#0068b7;
        padding: 10px 15px;
        border-radius: 3px;
        margin-top: 15px;
    }
    .order-list .goods>span{display: inline-block;margin-right: 15px;margin-top: 20px}
    .order-list .goods img{
        width: 80px;
        height: 80px;
    }
    .order-btn{
        margin: 30px 0;
        text-align: center;
        button{
            border: 0;
            background-color:  #f74845;
            color: white;
            border-radius: 3px;
            padding: 5px 15px;
            margin: 0 10px;
        }
    }
    .mt20{
        margin-top: 25px;
    }

    //凭证
    .wrapper .right-detail{
        position: relative;
        text-align: center;
        width: 59%;
        box-sizing: border-box;
        padding: 0 60px;
    }
    .right-detail  .img-box{
        position: relative;
        width: 100%;
        height: 500px;
    }
    .right-detail  .show-img{
        position: absolute;
        top: 0;
        left: 0;
        margin-bottom: 20px;
        height: 500px;
        box-shadow: 5px 5px 20px 8px #dedede;
    }
</style>



// WEBPACK FOOTER //
// src/router/OrderDetail1.vue